import FJUtil from '../../util/FJUtil.js';
import FJMessageStore from '../../store/FJMessageStore.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import { setTab, setPeopleImageInfo, setHairInfo, resetHairstyleChanger } from '../slices/FJSliceHairstyleChanger.js';
import FJNetworkStore from '../../store/FJNetworkStore.js';
import { setSliceTaskStatusAction, setSliceCreationListAction } from '../slices/FJSliceCommon.js';
import FJConstant from '../../constants/FJConstant.js';
import FJCompressedImageStore from '../../store/FJCompressedImageStore.js';
import FJActionCommon from '../../redux/action/FJActionCommon.js';
import FJAIHairstyleChangerConfig from '../../config/appConfig/FJAIHairstyleChangerConfig.js';
import FJAppConstant from '../../constants/FJAppConstant.js';
import FJImageStore from '../../store/FJImageStore.js';
import FJActionModal from './FJActionModal.js';
import { UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE } from '../../config/dataConfig/FJGenerateData';
import {
    getHairstyleAndColorInfo,
    HAIR_STYLE_NO_CHANGE,
    HAIRSTYLE_GENDER_FEMALE,
    HAIRSTYLE_GENDER_MALE,
    HAIRSTYLE_TAB_LIST,
} from '../../config/dataConfig/FJHairstyleChangerDataConfig.js';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore.js';
import FJAIVideoGeneratorConfig from '../../config/appConfig/FJAIVideoGeneratorConfig.js';

let f_eventId = null;

let _currentId = null;

const _checkIsCurrentTimingId = currentTimingId => {
    return _currentId === currentTimingId;
};

const doNotShowId = 'doNotShowHairstyleChangerModal';

function _getTabIndexByGender(gender) {
    const idx = HAIRSTYLE_TAB_LIST.findIndex(item => item.text === gender);
    // 当 gender === 'none' 时默认为 color
    return idx === -1 ? 2 : idx;
}

const FJActionHairstyleChanger = {
    editCloseAction: function () {
        return () => {
            _currentId = null;
        };
    },
    resetAction: function () {
        return dispatch => {
            _currentId = null;
            dispatch(resetHairstyleChanger());
        };
    },

    setTabAction: function (tab) {
        return dispatch => {
            dispatch(setTab(tab));
        };
    },

    uploadImageAction: function (file, skipTranscoded = false) {
        return async dispatch => {
            const isImage = FJUtil.isImage(file, true, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE);
            if (!isImage) {
                if (skipTranscoded) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                        'error',
                    );
                    return;
                }
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'image',
                            outputFormat: 'png',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadImageAction(newFiles[0]));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    file = result.files[0];
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                            'error',
                        );
                    }
                    return;
                }
            }

            const data = await FJCompressedImageStore.compressImageByFile(file);
            if (data) {
                dispatch(setPeopleImageInfo(data));
            } else {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            }
        };
    },

    setHairInfoAction: function (info) {
        return dispatch => {
            dispatch(setHairInfo(info));
        };
    },

    setHairColorAction: function (color) {
        return (dispatch, getState) => {
            const state = getState();
            dispatch(
                setHairInfo({
                    ...state.hairstyleChanger.hairInfo,
                    hairColor: color,
                }),
            );
        };
    },

    setHairstyleAction: function (style) {
        return (dispatch, getState) => {
            const state = getState();
            const gender = state.hairstyleChanger.hairInfo.gender;
            if (gender === HAIRSTYLE_GENDER_FEMALE)
                dispatch(
                    setHairInfo({
                        ...state.hairstyleChanger.hairInfo,
                        female: style,
                    }),
                );
            else if (gender === HAIRSTYLE_GENDER_MALE) {
                dispatch(
                    setHairInfo({
                        ...state.hairstyleChanger.hairInfo,
                        male: style,
                    }),
                );
            }
        };
    },

    setGenderAction: function (gender) {
        return (dispatch, getState) => {
            const state = getState();
            dispatch(
                setHairInfo({
                    ...state.hairstyleChanger.hairInfo,
                    gender,
                }),
            );
        };
    },

    // Generate logic
    _hairstyleChangerAction: function (data) {
        return async (dispatch, getState) => {
            const currentTimingId = new Date().getTime();
            _currentId = currentTimingId;

            const { tab } = getState().hairstyleChanger;

            const { peopleImageInfo, color, haircut, gender } = data;

            let { creditNumber, freeNumCreation } = getState().common;

            const __errorAndClear = () => {
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                dispatch(setSliceCreationListAction([]));
            };

            const __errorAndReLoad = () => {
                const creationList = getState().common.creationList;
                const reLoadList = creationList.map(i => ({
                    ...i,
                    isLoading: false,
                    isReload: true,
                }));
                dispatch(setSliceCreationListAction(reLoadList));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            };

            // 1.判断用户输入
            if (!peopleImageInfo.src) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-a-person-photo-first'), 'error');
                return;
            }

            if ((tab === 0 || tab === 1) && haircut === HAIR_STYLE_NO_CHANGE) {
                FJMessageStore.addMessage(FJLocalStore._('please-select-a-hairstyle-or-hair-color-first'), 'error');
                return;
            }

            // 2.开始状态修改
            const placeHolderList = FJUtil.createPlaceHolderList({
                count: 1,
                uploadImageInfo: peopleImageInfo,
                generateInfo: {
                    peopleImageInfo,
                    haircut,
                    color,
                    gender,
                },
            });

            dispatch(setSliceCreationListAction(placeHolderList));
            dispatch(setSliceTaskStatusAction(FJConstant.START));

            // 3.判断登陆
            const userSpaceType = await FJUtil.checkUserSpace();
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                __errorAndClear();
                return;
            }

            // 4.额度判断
            if (creditNumber < FJAIHairstyleChangerConfig.unitPrice && !freeNumCreation) {
                dispatch(FJActionModal.showUpgradeModalAction());
                __errorAndClear();
                return;
            }

            const isFree = creditNumber < FJAIHairstyleChangerConfig.unitPrice && freeNumCreation;

            FJUtil.eaLog('ai_hairstyle_changer_generate_click', {
                gender: gender,
                hairstyle: haircut,
                color,
                type: haircut === HAIR_STYLE_NO_CHANGE ? 'color changer' : 'hairstyle changer',
            });

            if (!_checkIsCurrentTimingId(currentTimingId)) {
                return;
            }

            try {
                // 5.上传s3
                const imageS3Url = await FJImageStore.upLoadFileToS3ByUrl(peopleImageInfo.src);

                if (!_checkIsCurrentTimingId(currentTimingId)) {
                    return;
                }

                if (!imageS3Url || getState().common.appType !== FJAppConstant.AI_HAIRSTYLE_CHANGER) {
                    FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                    __errorAndClear();
                    return;
                }

                const __request = async () => {
                    return await FJNetworkStore.hairstyleChanger({
                        input_image: imageS3Url,
                        haircut,
                        hair_color: color,
                        gender,
                    });
                };

                // 6.创建任务
                f_eventId = await FJActionCommon.createRequestTask(__request, dispatch);

                if (!_checkIsCurrentTimingId(currentTimingId)) {
                    return;
                }

                if (!f_eventId) {
                    FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                    __errorAndClear();
                    return;
                }

                // 7.积分冻结
                FJUtil.updateAllCreditInfo(isFree);
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });

                // 8.轮询任务状态
                const __callback = data => {
                    if (!_checkIsCurrentTimingId(currentTimingId)) {
                        return;
                    }

                    const { type, errorMessage } = data;
                    if (type === FJConstant.ERROR) {
                        if (errorMessage) {
                            FJMessageStore.addMessage(errorMessage, 'error');
                        }
                        __errorAndReLoad();
                    } else if (type === FJConstant.SUCCESS) {
                        FJUtil.eaLog('ai tool generate success', {
                            tool: FJUtil.getToolName(),
                            'credit&free': isFree ? 'free' : 'credit',
                        });

                        try {
                            const logData = {
                                gender: gender,
                                hairstyle: haircut,
                                color,
                                type: haircut === HAIR_STYLE_NO_CHANGE ? 'color changer' : 'hairstyle changer',
                            };
                            FJUtil.eaLog('ai_hairstyle_changer_generate_success', logData);
                        } catch (e) {
                            console.log(e);
                        }
                    }
                };

                dispatch(
                    FJActionCommon.pollingTaskAction([f_eventId], {
                        callback: __callback,
                        isUseFree: isFree,
                    }),
                );
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                __errorAndReLoad();
            }
        };
    },

    generateAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const { male, female, hairColor, gender } = state.hairstyleChanger.hairInfo;
            const peopleImageInfo = state.hairstyleChanger.peopleImageInfo;
            dispatch(
                this._hairstyleChangerAction({
                    peopleImageInfo,
                    color: hairColor.value,
                    haircut:
                        gender === HAIRSTYLE_GENDER_FEMALE
                            ? female.value
                            : gender === HAIRSTYLE_GENDER_MALE
                              ? male.value
                              : HAIR_STYLE_NO_CHANGE,
                    gender,
                }),
            );
        };
    },

    reGenerateAction: function (id) {
        return async (dispatch, getState) => {
            const { creationList } = getState().common;
            const item = creationList.find(item => item.id === id);
            if (!item?.generateInfo) return;

            const { peopleImageInfo, haircut, color, gender } = item.generateInfo;

            // 重置图片信息
            if (peopleImageInfo) {
                dispatch(setPeopleImageInfo(peopleImageInfo));
            }

            // 重置性别
            if (gender) {
                dispatch(this.setGenderAction(gender));
            }

            // 重置发型和颜色信息
            const { hairstyle, hairColor } = getHairstyleAndColorInfo(gender, haircut, color);
            if (hairstyle) {
                dispatch(this.setHairstyleAction(hairstyle));
            }
            if (hairColor) {
                dispatch(this.setHairColorAction(hairColor));
            }

            // 重置tab
            const tabIndex = _getTabIndexByGender(gender);
            dispatch(this.setTabAction(tabIndex));

            // 执行重新生成
            dispatch(this._hairstyleChangerAction(item.generateInfo));
        };
    },

    /**
     * 通过rec_id获取 分享页，着陆页等预设数据
     * localstorage 数据结构
     * - fileList 用户文件
     * - avator 预设图片
     * - presetData 预设参数
     * - rest
     * @returns undefined
     */
    initHairstylePresetDataAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                if (!window.isEditPage) {
                    const url = location.origin + location.pathname;
                    FJUtil.changeLocation(url);
                }
                window.localStorage.removeItem(recId);
                const { fileList, avator, presetData, ...rest } = recIdInfo;
                if (fileList) {
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;

                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(this.uploadImageAction(file, true));
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    dispatch(this.uploadImageAction(blob, true));
                } else if (presetData) {
                    const { haircut, color, gender } = presetData;
                    const { hairstyle, hairColor } = getHairstyleAndColorInfo(gender, haircut, color);
                    dispatch(this.setGenderAction(gender));
                    dispatch(this.setHairstyleAction(hairstyle));
                    dispatch(this.setHairColorAction(hairColor));

                    dispatch(this.setTabAction(_getTabIndexByGender(gender)));
                } else if (rest) {
                    const { haircut, color, gender } = rest;
                    const { hairstyle, hairColor } = getHairstyleAndColorInfo(gender, haircut, color);
                    dispatch(this.setGenderAction(gender));
                    dispatch(this.setHairstyleAction(hairstyle));
                    dispatch(this.setHairColorAction(hairColor));

                    dispatch(this.setTabAction(_getTabIndexByGender(gender)));
                }
            }
        };
    },

    initHairstyleDemonstrationAction: function () {
        return (dispatch, getState) => {
            const isApply = localStorage.getItem(doNotShowId);
            const state = getState();

            if (!isApply && !state.modals.doNotShowAgainData.display) {
                dispatch(
                    FJActionModal.showDoNotShowAgainModalAction({
                        type: FJAppConstant.AI_HAIRSTYLE_CHANGER,
                        id: doNotShowId,
                        callback: flag => {
                            if (flag) {
                                FJUtil.eaLog('ai_hairstyle_changer_not_show_again_click');
                            }
                        },
                    }),
                );
            } else return;
        };
    },

    /**
     * @description 下载创作
     */
    downloadAllCreationAction: function (callback) {
        return async (dispatch, getState) => {
            const { creationList } = getState().common;
            if (creationList.length === 0) return;
            const ids = creationList.map(item => item.id);
            dispatch(FJActionCommon.multiDownloadAction(ids, 'creation', callback));
        };
    },

    /**
     * @description 添加至 editor
     */
    animateImageAction: function () {
        return async (dispatch, getState) => {
            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai_image_tool_to_video_generator_click', {
                tool: tool,
            });

            const creationList = getState().common.creationList;
            const avator = creationList[0]?.imgUrl || '';
            if (!avator) return;
            const recId = `${Date.now()}${Math.random().toString(36).substr(2, 9)}`;
            localStorage.setItem(recId, JSON.stringify({ avator }));
            const toolName = FJUtil.getAIToolHref(FJAIVideoGeneratorConfig.currentMenuName);
            const url = FJUtil.getCurrentUrl() + toolName.slice(1) + '?rec_id=' + recId;

            window.open(url, '_blank');
        };
    },
};

export default FJActionHairstyleChanger;
